import * as log from 'loglevel';
import AxiosAPI from './AxiosAPI';
// import $store from '../store/index';
import firebase from '../config/firebase';

class User extends AxiosAPI {
  constructor() {
    super();
    this.user = window.$store ? window.$store.getters.user : {};
  }

  getCurrentUser() {
    return window.$store.getters.user;
  }

  isLoggedIn() {
    return new Promise((resolve, reject) => {
      window.$cognitoAuth.isAuthenticated((err, authenticated) => {
        if (err || !authenticated) {
          return reject();
        }
        return resolve(true);
      });
    });
  }

  // getIdToken() {
  //   return new Promise((resolve, reject) => {
  //     firebase.auth().currentUser.getIdToken().then(resp => {
  //       resolve(ressp)
  //     }).catch(error => {
  //       reject(error.message)
  //     })
  //   })
  // }

  getUserToken() {
    const user = firebase.auth().currentUser;
    return user ? user.getIdToken().then(res => res) : null;
  }

  setUserToken(token) {
    window.$store.commit('setToken', token);
    // super.setDefaultHeader('X-Id-Token', token)
  }

  register(user) {
    return new Promise((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(() => {
        this.verifyAuthentication().then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        });
      }).catch((error) => {
        reject(error.message);
      });
    });
  }

  registerToLuminary(marketingConsent, fingerprintId) {
    const { country } = window.$store.getters;
    return new Promise((resolve, reject) => {
      super.post('v1/user/register', {
        country,
        marketing_consent: marketingConsent,
        branch_fingerprint_id: fingerprintId,
      }).then((resp) => {
        window.$store.commit('setUser', resp.user);
        window.$store.commit('setLoggedIn', true);
        resolve(resp);
      }).catch((error) => {
        log.error(error);
        reject(error.message);
      });
    });
  }

  loginToLuminary(fingerprintId) {
    const { country } = window.$store.getters;
    return new Promise((resolve, reject) => {
      super.post('v1/user/login', {
        country,
        branch_fingerprint_id: fingerprintId,
      }).then((resp) => {
        window.$store.commit('setUser', resp.user);
        window.$store.commit('setLoggedIn', true);
        resolve(resp);
      })
        .catch((error) => {
          log.error(error);
          this.logout();
          reject(error.message);
        });
    });
  }

  refreshUser(identify = true) {
    return new Promise((resolve, reject) => {
      super.getList('v1/user').then((resp) => {
        if (identify) {
          window.$store.commit('setUser', resp);
          // window.$analytics.identify(resp.uuid);
        }
        resolve(resp);
      }).catch((error) => {
        if (identify) {
          this.logout();
        }
        reject(error);
      });
    });
  }

  authenticate(user) {
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(user.email, user.password).then(() => {
        this.verifyAuthentication().then(() => {
          resolve();
        }).catch((error) => {
          reject(error.message);
        });
      }).catch((error) => {
        reject(error);
      });
    });
  }

  async verifyAuthentication() {
    const token = await this.getUserToken();
    return new Promise((resolve, reject) => {
      if (token) {
        // this.setUserToken(token)
        resolve();
      } else {
        this.logout(); // if token not found then logout user
        reject(new Error('Token not found'));
      }
    });
  }

  updateFirebaseInfo(userData) {
    return new Promise((resolve, reject) => {
      const user = firebase.auth().currentUser;
      if (user) {
        user.updateProfile({
          displayName: `${userData.first_name} ${userData.last_name}`,
          photoURL: userData.imageUrl,
        }).then((resp) => {
          resolve(resp);
        }).catch((error) => {
          reject(error.message);
        });
      }
    });
  }

  updateFirebaseEmail(userData) {
    return new Promise((resolve, reject) => {
      const user = firebase.auth().currentUser;
      if (user) {
        user.updateEmail(userData.email).then((resp) => {
          resolve(resp);
        }).catch((error) => {
          reject(error.message);
        });
      } else {
        reject(new Error('User not found'));
      }
    });
  }

  updateUserInfo(_userData) {
    const userData = _userData;
    return new Promise((resolve, reject) => {
      delete userData.imageUrl;
      const formData = userData;
      super.post('v1/user/update', formData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updateUserPassword(newpass) {
    return new Promise((resolve, reject) => {
      const user = firebase.auth().currentUser;
      if (user) {
        user.updatePassword(newpass).then((resp) => {
          resolve(resp);
        }).catch((error) => {
          reject(error.message);
        });
      }
    });
  }

  forgotPassword(email) {
    return new Promise((resolve, reject) => {
      firebase.auth().sendPasswordResetEmail(email)
        .then((resp) => {
          log.info(resp);
          resolve();
        })
        .catch(() => {
          reject(new Error('This email is not registered with us.'));
        });
    });
  }

  resetPassword(actionCode, newPassword) {
    return new Promise((resolve, reject) => {
      firebase.auth().confirmPasswordReset(actionCode, newPassword)
        .then((resp) => {
          resolve(resp);
        })
        .catch(() => {
          reject(new Error('We were unable to reset your password.'));
        });
    });
  }

  reAuthenticateUser(password) {
    return new Promise((resolve, reject) => {
      const user = firebase.auth().currentUser;
      const credentials = firebase.auth.EmailAuthProvider.credential(
        user.email,
        password,
      );
      // Prompt the user to re-provide their sign-in credentials
      user.reauthenticateAndRetrieveDataWithCredential(credentials).then((_user) => {
      // User re-authenticated.
        log.info('Authenticated user confirmed.');
        resolve(_user);
      }).catch((error) => {
      // An error happened.
        reject(error);
      });
    });
  }

  // resetPassword(username, verificationCode, newPassword) {
  //   return new Promise((resolve, reject) => {
  //     window.$cognitoAuth.confirmPassword(username, verificationCode, newPassword, (error, resp) => {
  //       if (error) {
  //         reject(error.message)
  //       } else {
  //         resolve(resp)
  //       }
  //     })
  //   })
  // }

  // getLibraryData(){
  //   return new Promise((resolve,reject)=>{
  //     super.get("library")
  //     .then(resp=>{
  //       resolve(resp)
  //     })
  //     .catch(err=>{
  //       reject(err)
  //     })
  //   })
  // }

  loadUserCategories() {
    return new Promise((resolve, reject) => {
      super.getList('v1/user/categories').then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  loadUserTopics() {
    return new Promise((resolve, reject) => {
      super.getList('v1/user/onboarding_topics').then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  saveOnboardingTopics(topics) {
    return new Promise((resolve, reject) => {
      // const formData = {
      //   body: topics,
      // };
      super.put('v1/user/onboarding_topics', topics).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  addUserCategory(categoryUuid) {
    return new Promise((resolve, reject) => {
      const formData = {
        categoryUuid,
      };
      super.post('v1/user/categories', formData).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  removeUserCategory(userCategoryUUID) {
    return new Promise((resolve, reject) => {
      super.delete(`v1/user/categories/${userCategoryUUID}`).then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendLuminaryFeedback(feedback, userEmail) {
    return new Promise((resolve, reject) => {
      const formData = {
        comment: feedback,
        email: userEmail,
      };
      super.post('v1/user/account_feedback', formData).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  logout() {
    firebase.auth().signOut()
      .then(() => {
        window.$store.dispatch('setDiscover', []);
        window.$store.dispatch('logout');
        window.$store.dispatch('emptyUserLibraryPodcasts');
        window.$store.dispatch('emptyUserLibraryEpisodes');
        window.$store.commit('setUserSubscription', {});
        this.setUserToken(null);

        super.post('v1/user/logout');
      })
      .catch((error) => {
        log.error(error.message);
      });
  }
}

export default User;



// WEBPACK FOOTER //
// ./app/src/services/User.js